var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7a4.875 4.875 0 1 0-9.75 0 4.875 4.875 0 0 0 9.75 0M1 7a6 6 0 1 1 12 0A6 6 0 0 1 1 7m3.98-2.125A1.315 1.315 0 0 1 6.216 4h1.366a1.479 1.479 0 0 1 .736 2.764l-.757.433a.564.564 0 0 1-1.125-.01v-.315c0-.202.108-.387.284-.488l1.038-.595a.354.354 0 0 0-.176-.661H6.217c-.08 0-.15.049-.176.124l-.01.028a.562.562 0 0 1-1.059-.375l.01-.028zM6.25 9.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
  })));
};
export default SvgQuestionCircle;